import { SelectItem } from 'primeng/api';

export interface Options {
  categories: SelectItem[];
  items: SelectItem[];
  beacons: SelectItem[];
  belts: SelectItem[];
  pipes: SelectItem[];
  cargoWagons: SelectItem[];
  fluidWagons: SelectItem[];
  fuels: SelectItem[];
  proliferatorModules: SelectItem[];
  recipes: SelectItem[];
}
